import iframeFilterOptions from "@/util/consts/iframeFilterOptions";

export default {
    props: {
        displayFilters: {
            type: Array,
            required: true
        },
        availableFilters: {
            type: Object
        },
        userParameter: {
            required: true,
            type: Object
        },
        iFrameType: {
            type: String,
            default: 'events'
        }
    },
    computed: {
        selectedCategories: {
            get() {
                return this.userParameter.categoryId ? this.userParameter.categoryId : []
            },
            set(categoryId) {
                this.$emit('update:userParameter', {...this.userParameter, categoryId})
            }
        },
        selectedType: {
            get() {
                return this.userParameter.typeId ? this.userParameter.typeId : []
            },
            set(typeId) {
                this.$emit('update:userParameter', {...this.userParameter, typeId})
            }
        },
        filterText: {
            get() {
                return this.userParameter.filterText
            },
            set(filterText) {
                this.$emit('update:userParameter', {...this.userParameter, filterText})
            }
        },
        dateFrom: {
            get() {
                return this.userParameter.dateFrom
            },
            set(dateFrom) {
                this.$emit('update:userParameter', {...this.userParameter, dateFrom})
            }
        },
        dateTo: {
            get() {
                return this.userParameter.dateTo
            },
            set(dateTo) {
                this.$emit('update:userParameter', {...this.userParameter, dateTo})
            }
        },
        forceAllCategories: {
            get() {
                return this.userParameter.forceAllCategories
            },
            set(forceAllCategories) {
                this.$emit('update:userParameter', {...this.userParameter, forceAllCategories})
            }
        },
        iframeFilterOptions() {
            return iframeFilterOptions
        },
        showTextFilter() {
            return this.displayFilters.includes(this.iframeFilterOptions.FILTER_TEXT)
        },
        showRangeFilter() {
            return this.displayFilters.includes(this.iframeFilterOptions.FILTER_RANGE)
        },
        showCategoryFilter() {
            return this.displayFilters.includes(this.iframeFilterOptions.FILTER_CATEGORIES) &&
                !!this.availableFilters?.categoriesUsedInEvents?.length
        },
        showEventTypeFilter() {
            return this.iFrameType !== 'appointments' &&
                this.displayFilters.includes(this.iframeFilterOptions.FILTER_TYPES) &&
                this.availableFilters?.eventTypesUsedInEvents?.length > 1
        },
        showMoreFilterArea() {
            return !!this.displayFilters.filter(filter => filter !== this.iframeFilterOptions.FILTER_TEXT).length
        }
    }
}
